import api from '../instance'

export function getMonthStatus(date) {
  return api.get('/generalSheetsStatus', {
    params: { date },
  })
}
